import React from "react";
import ReactDom from "react-dom";
import SearchForm from "./Forms/default-form";
import LegacyForm from "./Forms/legacy-form";

export default class SearchFormRenderer {
    constructor(container, data) {
        this._container = container;
        this._formData = data;
        this._version = data.version;
    }

    render() {
        ReactDom.render(this._getForm(), this._container);
    }

    destroy() {
        ReactDom.unmountComponentAtNode(this._container);
    }

    _getForm() {
        switch(this._version) {
            case 0: return (<LegacyForm {...this._formData} />);
            case 1:
            default: return (<SearchForm {...this._formData}/>);
        }
    }
};
